/* eslint-disable func-names */
(function(algolia) {
  if (!algolia.config.autocomplete_enabled) return;

  const { autocomplete, insightsClient } = algolia.externals;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const container = document.querySelector(algolia.config.input_selector);
  container.innerHTML = '';
  const containerClasses = container.classList;
  containerClasses.add('aa-MainContainer');

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin, algoliaInsightsPlugin } = algolia;
  const plugins = [
    algolia.config.analytics_enabled && algoliaInsightsPlugin,
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
  ];

  function setupTracking() {
    const products = document.querySelector('[data-autocomplete-source-id="products"]');

    if (!products) {
      return;
    }

    products.addEventListener('click', (e) => {
      e.preventDefault();

      let el = e.target;
      let hit;

      do {
        if (el.matches('.ais-hit')) {
          hit = el;
          break;
        }
        el = el.parentNode;
      } while (el && el !== products);
      if (!hit) {
        return;
      }

      const link = hit.querySelector('a').href;

      if (algolia.config.analytics_enabled) {

        // Retrieving userToken
        let userToken;
        insightsClient('getUserToken', null, (err, newUserToken) => {
          if (err) {
            window.console.error(err);
            return;
          }
          userToken = newUserToken;
        });

        const clickData = {
          userToken,
          index: hit.dataset.algoliaIndex,
          eventName: 'click',
          queryID: hit.dataset.algoliaQueryid,
          objectIDs: [hit.dataset.algoliaObjectid],
          positions: [Number(hit.dataset.algoliaPosition)],
        };

        // Send the click event
        insightsClient('clickedObjectIDsAfterSearch', clickData);
        algolia.saveForConversionTracking(clickData);
      }
      window.location.href = link;
    });
  }

  autocomplete({
    container: '#page-header-search-form',
    classNames: {
      clearButton: "search-form__reset",
      form: "search-form__form",
      input: "search-form__input",
      inputWrapper: "search-form__cell search-form__cell--input",
      inputWrapperPrefix: "search-form__cell search-form__cell--submit",
      inputWrapperSuffix: "search-form__cell search-form__cell--reset",
      item: "search-results__item",
      label: "search-form__label",
      list: "search-results__list list-reset",
      loadingIndicator: "search-form__loading-indicator",
      PanelSection: "search-results__wrapper",
      panelLayout: "content-wrapper",
      root: "search-form",
      source: "search-results__section",
      sourceFooter: "search-results__footer",
      sourceHeader: "search-results__header",
      sourceNoResults: "search-results--no-results",
      submitButton: "search-form__submit",
    },
    debug: algolia.config.autocomplete_debug,
    detachedMediaQuery: 'none',
    openOnFocus: false,
    panelContainer: '#page-header-search-results',
    panelPlacement: 'full-width',
    placeholder: WYATT.t.searchForm.placeholder,
    plugins,
    render({ elements, render, html, state }, root) {
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
              .filter(
                      ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
              )
              .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({ source }) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
      render(
              hasLeftPanelResults ?
              algolia.mainTemplate({ html, state }, elements, displaySuggestions)
              : algolia.mainProductsTemplate({ html, state }, elements),
              root
      );

      setupTracking();
    },
    renderNoResults({ render, html, state }, root) {
      render(
        algolia.noResultsTemplate({ html, state }),
        root
      )
    },
    onSubmit({ state }) {
      window.location.href = `/search?q=${state.query}`;
    }
  });
})(window.algoliaShopify);
